export const classes = {
  root: {
    fontSize: 'auto',
  },
};
